import { DetailedReactHTMLElement, ReactNode } from "react";
import { SelectOptionProps } from "./types";

export type ParsedSelectOption<T> = {
  value: T;
  label: string;
};

export const getOptionLabel = <T>(
  children: ReactNode,
  value: T,
  displayValue?: (value: T) => string | null,
): string => {
  if (displayValue) {
    const displayed = displayValue(value);
    if (displayed !== null) {
      return displayed;
    }
  }
  if (typeof children === "string" || typeof children === "number") {
    return String(children);
  }
  return String(value);
};

export const parseSelectOptions = <T>(
  children: DetailedReactHTMLElement<SelectOptionProps<T>, HTMLElement>[],
  displayValue?: (value: T) => string | null,
): ParsedSelectOption<T>[] =>
  children.map((child) => ({
    value: child.props.value,
    label: getOptionLabel(
      child.props.children,
      child.props.value,
      displayValue,
    ),
  }));

export const findSelectOptionIndex = <T>(
  options: ParsedSelectOption<T>[],
  value: T | undefined,
): number => {
  if (typeof value === "undefined") {
    return -1;
  }
  return options.findIndex((option) => option.value === value);
};
